function initAtlasGallery(gallery) {
  if (!gallery || gallery.dataset.galleryReady === 'true') return;
  gallery.dataset.galleryReady = 'true';

  const slides = [...gallery.querySelectorAll('[data-atlas-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-atlas-thumb]')];
  const previous = gallery.querySelector('[data-atlas-previous]');
  const next = gallery.querySelector('[data-atlas-next]');
  let active = 0;

  const show = (index) => {
    if (!slides.length) return;
    active = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== active;
    });
    thumbs.forEach((thumb, thumbIndex) => {
      const selected = thumbIndex === active;
      thumb.classList.toggle('is-active', selected);
      thumb.setAttribute('aria-current', selected ? 'true' : 'false');
    });
    thumbs[active]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  };

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
  previous?.addEventListener('click', () => show(active - 1));
  next?.addEventListener('click', () => show(active + 1));
  show(0);
}

function initAllAtlasGalleries(root = document) {
  root.querySelectorAll('[data-atlas-gallery]').forEach(initAtlasGallery);
}

initAllAtlasGalleries();
document.addEventListener('shopify:section:load', (event) => initAllAtlasGalleries(event.target));
